<template>
  <div></div>
</template>

<script>
export default {
  props: {
    elementsId: {
      type: Array,
      default: () => new Array,
    },
  },
  data() {
    return {
      currentIndex: 0,
    };
  },
  computed: {
    prevIsActive() {
      return this.elementsId[this.currentIndex - 1];
    },
    nextIsActive() {
      return this.elementsId[this.currentIndex + 1];
    },
  },
  methods: {
    prev() {
      if (!this.prevIsActive) {
        return;
      }

      this.currentIndex--;
      document.getElementById(this.getElementByIndex()).focus();
    },
    next(lastChar) {
      if (!this.nextIsActive) {
        return;
      }

      this.currentIndex++;
      let el = document.getElementById(this.getElementByIndex());
      el.focus();

      if (lastChar) {
        el.value = lastChar;
        el.dispatchEvent(new Event('input'));
      }
    },
    getElementByIndex() {
      return this.elementsId[this.currentIndex];
    },
    setCurrentIndex(id) {
      this.currentIndex = this.elementsId.findIndex(el => el === id);
    },
  },
};
</script>

<style lang="sass" scoped>
  div
    margin: 0 !important
    padding: 0 !important
    overflow: hidden
</style>
